import React, {useState} from "react";
import {connect, useDispatch} from "react-redux";
import {Link, useNavigate} from "react-router-dom";
// import {FaGoogle, FaFacebook, FaApple} from "react-icons/fa";

import {
  loadingToggleAction,
  loginAction,
  loginWithSc,
} from "../../store/actions/AuthActions";
import SideBg from "../components/shared/loginSideBg";
import GoogleIcon from "../../images/icons/GoogleIcon";
import AppleIcon from "../../images/icons/appleIcon";
import FacebookIcon from "../../images/icons/facebookIcon";
import * as yup from "yup";

import {signedBy} from "../../utils/constants";
import {
  FacebookAuthProvider,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import {auth} from "../../utils/firebase";
import {Formik} from "formik";
import {showToastModal} from "../components/shared/ToastModalSwal";
import {useTranslation} from "react-i18next";
import {getSocialAuthToast} from "../../utils/socialAuthMessages";

const CustomGoogleButton = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const {t} = useTranslation();

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      await dispatch(loginWithSc(user.email, user, signedBy.GOOGLE, navigate));
      showToastModal(getSocialAuthToast(t, signedBy.GOOGLE, undefined, "success"));
    } catch (error) {
      showToastModal(getSocialAuthToast(t, signedBy.GOOGLE, error));
    }
  };

  return (
    <button
      type="button"
      onClick={handleGoogleLogin}
      className="flex w-1/3 max-[769px]:w-full gap-2 items-center justify-center bg-white border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-[10px] "
    >
      <GoogleIcon />
      <div className="flex flex-col justify-start text-[#19295C]">
        <span className="font-normal text-[7px] text-start text-nowrap">
          Se connecter avec
        </span>
        <span className="font-semibold text-[14px] text-start">Google</span>
      </div>
    </button>
  );
};
// image

function Login(props) {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();
  const {t} = useTranslation();
  const schema = yup.object().shape({
    email: yup
      .string()
      .required("L'adresse e-mail est requise.")
      .email("Veuillez entrer une adresse e-mail valide."),

    password: yup.string().required("Champ obligatoire"),
  });

  const handleFacebookLogin = async () => {
    const provider = new FacebookAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      await dispatch(loginWithSc(user.email, user, signedBy.FACEBOOK, navigate));
      showToastModal(
        getSocialAuthToast(t, signedBy.FACEBOOK, undefined, "success"),
      );
    } catch (error) {
      showToastModal(getSocialAuthToast(t, signedBy.FACEBOOK, error));
    }
  };

  const handleAppleLogin = async () => {
    const provider = new OAuthProvider("apple.com");
    try {
      const result = await signInWithPopup(auth, provider);

      const user = result.user;
      await dispatch(loginWithSc(user.email, user, signedBy.APPLE, navigate));
      showToastModal(getSocialAuthToast(t, signedBy.APPLE, undefined, "success"));
    } catch (error) {
      showToastModal(getSocialAuthToast(t, signedBy.APPLE, error));
    }
  };
  //setEmail('');
  //setPassword('123456');

  return (
    <>
      <div className="row m-0 justify-content-center h-100 align-items-center">
        <div className="col-xl-6 col-xxl-8">
          <div className="authincation-content">
            <div className="row no-gutters">
              <div className="col-xl-12">
                <div className="auth-form">
                  <div className=" mb-3">
                    <h2 className="text-primary font-bold text-[28px] uppercase">
                      Se connecter
                    </h2>
                  </div>
                  <h4 className=" mb-4 ">Entrez vos coordonnées ci-dessous</h4>
                  {props.errorMessage && (
                    <div className="text-danger">{props.errorMessage}</div>
                  )}
                  {props.successMessage && (
                    <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                      {props.successMessage}
                    </div>
                  )}
                  <Formik
                    initialValues={{
                      email: "",
                      password: "",
                    }}
                    validationSchema={schema}
                    validateOnChange={false}
                    validateOnBlur={true}
                    onSubmit={(values, {setSubmitting}) => {
                      const {email, password} = values;
                      dispatch(loadingToggleAction(true));
                      dispatch(loginAction(email, password, navigate));
                      setSubmitting(false);
                    }}
                  >
                    {({
                      values,
                      errors,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      touched,
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <div className="form-group">
                          <label className="mb-2 font-medium ">Email</label>
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                          />
                          {touched.email && errors.email && (
                            <div
                              className="invalid-feedback animated fadeInUp"
                              style={{display: "block"}}
                            >
                              {errors.email}
                            </div>
                          )}
                        </div>
                        <div className="form-group">
                          <label className="mb-2 font-medium">
                            Mot de passe
                          </label>
                          {/* <input
                            type="password"
                            className="form-control"
                            name="password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                          /> */}
                          <div className="relative">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="form-control pr-10"
                              name="password"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.password}
                            />
                            <button
                              type="button"
                              className="absolute inset-y-0 right-3 flex items-center text-gray-500"
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? (
                                <i className="fi fi-rr-eye-crossed flex items-center"></i>
                              ) : (
                                <i className="fi fi-rr-eye flex items-center"></i>
                              )}
                            </button>
                          </div>
                          {touched.password && errors.password && (
                            <div
                              className="invalid-feedback animated fadeInUp"
                              style={{display: "block"}}
                            >
                              {errors.password}
                            </div>
                          )}
                        </div>
                        <div className="form-row d-flex justify-content-between mt-4 mb-2">
                          <div className="form-group">
                            <div className="custom-control custom-checkbox ml-1 ">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="basic_checkbox_1"
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="basic_checkbox_1"
                              >
                                Se souvenir de moi
                              </label>
                            </div>
                          </div>

                          <Link
                            to={"/mot-de-passe-oublie"}
                            className="text-sm underline font-medium text-right text-[#1A64B9] mr-2 "
                          >
                            Mot de passe oublié ?
                          </Link>
                        </div>
                        <div className="text-center">
                          <button
                            disabled={!!isSubmitting}
                            type="submit"
                            className="w-full flex justify-center font-medium items-center !rounded-md !py-3 text-white text-sm hover:!bg-[#1a71b9] !bg-[#1A64B9] !border-[#1A64B9]  uppercase"
                          >
                            {isSubmitting ? "Connexion" : "Se connecter"}
                          </button>
                        </div>
                      </form>
                    )}
                  </Formik>

                  <div className="new-account mt-3">
                    <p className="">
                      Vous n'avez pas de compte ?{" "}
                      <Link
                        className="text-primary underline"
                        to="/inscription"
                      >
                        Créer un compte
                      </Link>
                    </p>
                  </div>
                  <div className="flex w-full max-[769px]:flex-col justify-center gap-2 mt-4">
                    {/* <button className="flex gap-2  items-center justify-center bg-white border border-gray-300 text-gray-800 hover:bg-gray-100 px-4 py-2 rounded-lg shadow">
                        <i className="fa fa-google "></i> Connecter avec Google
                      </button> */}

                    <CustomGoogleButton />

                    <button
                      type="button"
                      onClick={handleFacebookLogin}
                      className="flex w-1/3 max-[769px]:w-full gap-2 items-center justify-center bg-white border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-[10px] "
                    >
                      <FacebookIcon />
                      <div className="flex flex-col justify-start text-[#19295C]">
                        <span className="font-normal text-[7px] text-start text-nowrap">
                          Se connecter avec
                        </span>
                        <span className="font-semibold text-[14px] text-start">
                          Facebook
                        </span>
                      </div>
                    </button>

                    <button
                      type="button"
                      onClick={handleAppleLogin}
                      className="flex w-1/3 max-[769px]:w-full gap-2 items-center justify-center bg-white border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-[10px] "
                    >
                      <AppleIcon />
                      <div className="flex flex-col justify-start text-[#19295C]">
                        <span className="font-normal text-[7px] text-start text-nowrap">
                          Se connecter avec
                        </span>
                        <span className="font-semibold text-[14px] text-start">
                          Apple
                        </span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};
export default connect(mapStateToProps)(Login);
